import * as React from 'react';

function SvgPendingNoShadow(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 31" {...props}>
      <g fill="#6D7FB4">
        <path d="M13.225 0h-.654L.658 4.227l-.053.026C.22 4.443 0 4.828 0 5.23v12.147c.03 1.047.558 2.852 1.734 4.75 1.973 3.155 5.451 6.057 10.771 8.272l.384.16.384-.16c5.171-2.145 8.628-4.942 10.666-8.095.737-1.14 1.24-2.257 1.548-3.31.199-.68.288-1.227.307-1.588l.002-.053V5.23c0-.44-.24-.796-.605-.977l-.054-.026L13.225 0zm-.327 2.006l10.897 3.867.002 11.427c-.003.054-.014.16-.038.308-.04.242-.102.519-.192.825-.255.871-.677 1.81-1.308 2.785l-.091.14c-1.764 2.655-4.726 5.065-9.187 6.993l-.09.039-.082-.035c-4.675-2.027-7.684-4.579-9.377-7.286l-.079-.128C2.423 19.4 2.018 18 2 17.349V5.873l10.898-3.867z" />
        <path d="M14.954 8.488l-.634 8.553c-.035.566-.566 1.002-1.165.954-.549-.033-.977-.453-1.011-.954l-.634-8.553c-.069-.905.65-1.697 1.61-1.746.96-.064 1.8.615 1.85 1.52 0 .08 0 .162-.016.226zM11.39 21.341c0 .954.822 1.73 1.833 1.73 1.011 0 1.833-.776 1.833-1.73 0-.953-.822-1.73-1.833-1.73-1.01 0-1.833.777-1.833 1.73z" />
      </g>
    </svg>
  );
}

export default SvgPendingNoShadow;
